import { useState } from 'react';

const faqs = [
  {
    question: 'Wie schnell seid ihr vor Ort?',
    answer:
      'Das hängt von Uhrzeit, Verkehr, Einsatzlage und Standort ab. Am Telefon bekommst du eine realistische Einschätzung zur aktuellen Verfügbarkeit und zum nächsten sinnvollen Schritt.'
  },
  {
    question: 'Wann brauche ich einen Abschleppdienst oder Pannendienst in Berlin?',
    answer:
      'Wenn dein Fahrzeug wegen einer Panne oder eines Unfalls nicht mehr fahrbereit ist oder wenn ein Falschparker deine Einfahrt, Zufahrt oder deinen Privatparkplatz blockiert. Auch Motorrad- und Rollertransporte sind möglich.'
  },
  {
    question: 'Kann ich auch nachts oder am Wochenende anrufen?',
    answer:
      'Ja. Schiek ist 24/7 erreichbar, also auch nachts, am Wochenende und an Feiertagen. Der direkte Anruf ist im Ernstfall immer der schnellste Weg.'
  },
  {
    question: 'Arbeitet Schiek über Clubkarten oder Mitgliedschaften?',
    answer:
      'Nein. Schiek ist ein privater Abschlepp- und Bergungsdienst. Du beauftragst uns direkt, ohne Mitgliedschaft und ohne Vermittlungsplattform.'
  },
  {
    question: 'Wie läuft ein Abschlepp-Einsatz in Berlin ab?',
    answer:
      'Du rufst an, schilderst kurz die Situation und nennst Standort und Fahrzeugtyp. Danach bekommst du eine Einschätzung. Wenn du zustimmst, fahren wir an, sichern die Lage ab und transportieren das Fahrzeug zum Ziel.'
  },
  {
    question: 'Wie wird ein Einsatz bezahlt?',
    answer:
      'In der Regel direkt nach dem Einsatz vor Ort. Je nach Situation ist Bar- oder Kartenzahlung möglich. Wenn du eine Rechnung brauchst, stellen wir sie aus.'
  },
  {
    question: 'Was passiert bei Falschparkern auf Privatgrund?',
    answer:
      'Wenn du berechtigt bist, dokumentieren wir die Situation vor Ort und besprechen den weiteren Ablauf. Öffentlicher Straßenraum bleibt Sache von Polizei oder Ordnungsamt.'
  }
];

export default function SpecialsSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);

  const handleToggle = (index: number) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" aria-labelledby="faq-heading" className="bg-[#f4f1ea] py-16 text-slate-950">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-semibold text-amber-700">Fragen und Antworten</p>
          <h2 id="faq-heading" className="mt-3 text-3xl font-semibold leading-tight sm:text-4xl">
            Häufige Fragen zum Abschleppdienst in Berlin.
          </h2>
          <p className="mt-4 text-base leading-8 text-slate-700">
            Die wichtigsten Punkte sind direkt beantwortet. Wenn etwas offen bleibt, ist der Telefonkontakt weiterhin der schnellste Weg.
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((item, index) => {
            const isActive = activeIndex === index;
            return (
              <div key={item.question} className="overflow-hidden rounded-[1.5rem] border border-slate-300 bg-white shadow-[0_14px_30px_rgba(15,23,42,0.06)]">
                <button
                  type="button"
                  onClick={() => handleToggle(index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isActive}
                  aria-controls={`faq-panel-${index}`}
                >
                  <span className="text-sm font-semibold leading-6 text-slate-950 sm:text-base">{item.question}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-slate-300 bg-slate-50 text-lg text-slate-700 transition-transform duration-200 ${
                      isActive ? 'rotate-45' : ''
                    }`}
                  >
                    +
                  </span>
                </button>
                {isActive && (
                  <div id={`faq-panel-${index}`} role="region" className="px-5 pb-5">
                    <p className="text-sm leading-7 text-slate-700 sm:text-base">{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
